module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-right.e44462f9.svg";